// MultiSelectDropdown.tsx
import React, { FC } from 'react';
import Select, { MultiValue, Options, components } from 'react-select';


interface MultiSelectDropdownProps {
    options: Array<{ value: number; label: string }>;
    selectedValues: Array<{ value: number; label: string }>
    onChange: (selectedValues: number[]) => void;
}

const ProvidersDropdown: FC<MultiSelectDropdownProps> = ({ options, selectedValues, onChange }) => {

    const handleChange = (selected: MultiValue<{ value: number; label: string }>) => {

        if (selected.length) {
            const prs = selected.map(option => option.value);
            onChange(prs)
        }
    }
    const customStyles = {
        menu: (provided:any, state:any) => ({
          ...provided,
          zIndex: '20'
        }),
    }
    return (
        <Select
            isMulti
            options={options}
            hideSelectedOptions={false}
            value={selectedValues}
            onChange={handleChange}
            controlShouldRenderValue={false}
            placeholder='Providers'
            closeMenuOnSelect={false}
            styles={customStyles} 
            classNamePrefix="providers-select"
        />
    );
};

export default ProvidersDropdown;
